import React, { useEffect, useState, useMemo } from 'react';
import styles from './Notifications.module.scss';
import { Icon } from '../../../../components/Icon';
import { useUserContext } from '../../../../context/UserContext';
import { CustomButton } from '../../../../components/Button/Button';
import { useTranslation } from 'react-i18next';
import { SettingsTable } from '../SettingsTable/SettingsTable';
import CmsAPI from '../../../../../common/apis/CmsAPI';
import Spinner from '../../../../../common/components/Spinner';

const mediumTypes = {
  email: 1,
};

export const Notifications = () => {
  const { user, notificationSettings, changeSetting, setNotificationSettings } = useUserContext();

  const [permission, setPermission] = useState(true);
  const [isEmailEnabled, setIsEmailEnabled] = useState(false);
  const [isEmailEnableLoading, setIsEmailEnableLoading] = useState(false);

  const { t } = useTranslation();

  const emailEnabled = useMemo(() => {
    return isEmailEnabled;
  }, [isEmailEnabled]);

  useEffect(() => {
    if (notificationSettings?.mediumSettings) {
      const result = notificationSettings?.mediumSettings?.find(({ medium }) => medium === mediumTypes.email)?.value;

      if (result !== undefined) {
        setIsEmailEnabled(result);
      }
    }
  }, [notificationSettings]);

  useEffect(() => {
    return async () => {
      const result = await CmsAPI.getNotificationSettings();
      if (result) {
        setNotificationSettings(result);
      }
    };
  }, []);

  const handleEmailChange = async () => {
    setIsEmailEnabled(!isEmailEnabled);
    const emailSettings = notificationSettings?.mediumSettings?.find(({ medium }) => medium === mediumTypes.email);
    const settings = [
      {
        id: emailSettings.id,
        medium: emailSettings.medium,
        enabled: !isEmailEnabled,
      },
    ];

    const undoSetting = () => {
      setIsEmailEnabled(prevState => !prevState);
    };

    setIsEmailEnableLoading(true);
    await changeSetting(settings, undoSetting);
    setIsEmailEnableLoading(false);
  };

  return (
    user && (
      <div className={styles.notificationContainer}>
        {!permission && (
          <div className={styles.permissionContainer}>
            <div className={styles.title}>{t('account.settings.notifications.permissions')}</div>
            <div className={styles.permissionsNotification}>
              <div>
                <Icon className={styles.notificationIcon} src="active" />
                <div className={styles.permissionAlertContent}>
                  <div className={styles.permissionAlertTitle}>
                    {t('account.settings.notifications.permissions.description_first')}
                  </div>
                  <p>{t('account.settings.notifications.permissions.description_second')}</p>
                </div>
              </div>
              <CustomButton
                variant="primary"
                label={t('account.settings.notifications.permissions.allow')}
                customStyles={{
                  padding: '6px 12px',
                }}
              />
            </div>
          </div>
        )}
        <div className={styles.notificationSettingsContainer}>
          <h1>{t('account.settings.notifications.title')}</h1>
          <div className={styles.notifyEmailContainer}>
            <h2>{t('account.settings.notifications.notify_me_when')}</h2>
            <CustomButton
              variant="link"
              className={styles.toggleButton}
              label={
                isEmailEnabled ? t('account.settings.notifications.email.turn_off') : t('account.settings.notifications.email.turn_on')
              }
              onClick={handleEmailChange}
              disabled={isEmailEnableLoading}
            />
          </div>
          {notificationSettings?.settings?.length ? (
            notificationSettings?.settings?.map(item => (
              <SettingsTable
                key={`${item.label} ${mediumTypes.email}`}
                mediumType={mediumTypes.email}
                item={item}
                changeSetting={changeSetting}
                isEnabled={emailEnabled}
              />
            ))
          ) : (
            <Spinner width="40px" height="40px" size="4px" className={styles.spinner} />
          )}
        </div>
      </div>
    )
  );
};
